import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { pollPaymentStatus, readLastSession, rememberedPlates } from "@/lib/api";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [session] = useState(() => readLastSession());
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!session?.sid) {
      navigate("/", { replace: true });
      return;
    }
    let stop = false;
    const tick = async () => {
      try {
        const st = await pollPaymentStatus(session.sid);
        if (st.payment_status === "paid") {
          rememberedPlates.add(session.targa);
          toast.success("Pagamento confermato!");
          navigate(`/report/${session.targa}`, { replace: true });
          return;
        }
      } catch {
        // keep polling
      }
      if (!stop) setTimeout(() => setTries((t) => t + 1), 2500);
    };
    tick();
    return () => {
      stop = true;
    };
  }, [tries, session, navigate]);

  return (
    <div className="min-h-[75vh] flex flex-col items-center justify-center gap-5 text-center px-6">
      <motion.div
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 200, damping: 15 }}
      >
        <CheckCircle2 size={64} className="text-[#00ff88]" data-testid="payment-success-icon" />
      </motion.div>
      <h1 className="font-orbitron text-2xl tracking-widest">PAGAMENTO COMPLETATO</h1>
      <p className="text-sm text-[#8a8a9e] flex items-center gap-2" data-testid="payment-polling-status">
        <Loader2 size={14} className="animate-spin text-[#00f0ff]" /> Preparazione del report in corso...
      </p>
      {session?.targa && (
        <p className="font-jetmono text-[10px] tracking-[0.3em] text-[#8a8a9e]">TARGA {session.targa}</p>
      )}
    </div>
  );
}
